export default __webpack_public_path__ + "static/negative-former-eksempel2-b7917b056c6df59a8de39f19a54496db.png";